import styled from "styled-components";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const IMAGE_WIDTH = 44;

export interface NudgeCrossSellProps {
    isCrossSell?: boolean;
    isCashback?: boolean;
}

export const NudgeImageWrapper = styled.div<NudgeCrossSellProps>(
    ({ theme }) => ({
        height: "100%",
        width: `${IMAGE_WIDTH}px`,
        marginRight: theme.spacing.medium,
    }),
    ({ isCashback, theme }) =>
        isCashback && {
            marginLeft: `calc(${theme.spacing.xxSmall} * -1)`,
            display: "flex",
            "> img": {
                height: "14px",
                width: "auto",
            },
        },
);

const leftPadding = (isCashback = false, isCrossSell = false) => {
    if (isCashback) {
        return "50%";
    } else if (isCrossSell) {
        return "30%";
    } else {
        return "75%";
    }
};

export const NudgeContainer = styled.div<NudgeCrossSellProps>(({ theme, isCrossSell, isCashback }) => ({
    display: isCashback ? "block" : "flex",
    borderRadius: theme.cornerRadius.small,
    alignItems: "center",
    padding: `${theme.spacing.small} ${theme.spacing.xSmall}`,
    background: theme.colors.light.background_Secondary_Alpha,
    margin: isCrossSell ? theme.spacing.medium : undefined,
    marginTop: isCrossSell ? "0" : theme.spacing.medium,
    position: "relative",

    "::before": {
        content: '""',
        position: "absolute",
        top: "-10px",
        // eslint-disable-next-line no-nested-ternary
        left: leftPadding(isCashback, isCrossSell),
        transform: "translateX(-50%)",
        borderLeft: `10px solid transparent`,
        borderRight: `10px solid transparent`,
        borderBottom: `10px solid ${theme.colors.light.background_Secondary_Alpha}`,
    },
}));

export const NudgeText = styled(Text)<NudgeCrossSellProps>(
    ({ theme, isCrossSell }) => ({
        marginLeft: isCrossSell ? theme.spacing.small : undefined,
    }),
    ({ isCashback, theme }) =>
        isCashback && {
            marginTop: theme.spacing.xxxSmall,
        },
);
